import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="ai-footer">
    <div className="ai-wrap">
      <div>
        <Link to="/" className="ai-wordmark">
          <span className="ai-mark" aria-hidden="true" />
          <span>Afterimage <small>Labs</small></span>
        </Link>
        <p>We find the diagnoses that medicine missed and make sure someone answers for them.</p>
      </div>
      <nav aria-label="Footer">
        <Link to="/mission">Mission</Link>
        <Link to="/impact">Impact</Link>
        <Link to="/careers">Get involved</Link>
        <a href="mailto:hello@afterimage.health">hello@afterimage.health</a>
      </nav>
      <p className="legal">&copy; {new Date().getFullYear()} Afterimage Labs</p>
    </div>
  </footer>
);

export default Footer;
